import type { CSSProperties } from 'react'
import { ContentGroup } from '@/shared/ui'
import { designTokens } from '@/shared/lib/design-tokens'
import { typographyStyle } from '@/shared/lib/catalog'

const titleTypography = designTokens.typography.body.mdSemibold
const itemTypography = designTokens.typography.body.md

const titleStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.deep,
  ...typographyStyle(titleTypography),
}

const itemStyle = {
  fontFamily: designTokens.typography.fontFamilies.primary,
  color: designTokens.colors.text.primary,
  ...typographyStyle(itemTypography),
}

const checklistItems = [
  { text: 'Создайте ваш аккаунт', completed: true },
  { text: 'Настройте свой профиль', completed: true },
  { text: 'Оформите подписку', completed: true },
  {
    text: 'Переходите в телеграм-бот участников комьюнити, чтобы получить доступ ко всем направлениям подписки',
    completed: false,
  },
]

export type OnboardingChecklistProps = {
  className?: string
  style?: CSSProperties
}

export function OnboardingChecklist({ className, style }: OnboardingChecklistProps) {
  return (
    <ContentGroup
      variant="contentDesktop"
      className={className}
      style={{
        height: designTokens.components.onboarding.desktop.panelHeight,
        ...style,
      }}
    >
      <p style={titleStyle}>Последний шаг</p>
      {checklistItems.map((item) => (
        <div
          key={item.text}
          className="flex w-full"
          style={{
            gap: designTokens.spacing.subscriptionBenefitIconGap,
            alignItems: item.completed ? 'center' : 'flex-start',
          }}
        >
          <ChecklistIcon completed={item.completed} />
          <p
            style={{
              ...itemStyle,
              opacity: item.completed ? 0.7 : 1,
              textDecorationLine: item.completed ? 'line-through' : 'none',
              textDecorationStyle: item.completed ? 'solid' : undefined,
              textDecorationSkipInk: item.completed ? 'none' : undefined,
              textUnderlinePosition: item.completed ? 'from-font' : undefined,
              whiteSpace: 'pre-wrap',
            }}
          >
            {item.text}
          </p>
        </div>
      ))}
    </ContentGroup>
  )
}

type ChecklistIconProps = {
  completed: boolean
}

function ChecklistIcon({ completed }: ChecklistIconProps) {
  const size = designTokens.sizes.width.subscriptionBenefitIcon

  return (
    <span style={{ width: size, height: size, minWidth: size, minHeight: size }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        aria-hidden="true"
      >
        <rect
          x="0.5"
          y="0.5"
          width="17"
          height="17"
          rx={designTokens.borders.radius.subscriptionBenefitIcon}
          fill={designTokens.colors.background.white}
        />
        <rect
          x="0.5"
          y="0.5"
          width="17"
          height="17"
          rx={designTokens.borders.radius.subscriptionBenefitIcon}
          stroke={designTokens.colors.border.neutralLight}
        />
        {completed ? (
          <path
            d="M14 6L7.125 13L4 9.81818"
            stroke={designTokens.colors.background.paymentScheduleActive}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        ) : null}
      </svg>
    </span>
  )
}
